/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import AppContainerPicker from 'shared/ui/components/form-components/pickers/AppContainerPicker.vue';
import BaseInput from 'shared/ui/components/form-components/BaseInput.vue';
import BaseSelect from 'shared/ui/components/form-components/BaseSelect.vue';
import ContainerPicker from 'shared/ui/components/form-components/pickers/ContainerPicker.vue';
import DatetimePicker from 'shared/ui/components/form-components/pickers/DatetimePicker.vue';
import RegistrationUrlPicker from 'shared/ui/components/form-components/pickers/RegistrationUrlPicker.vue';
import WizardStep from 'shared/ui/components/WizardStep.vue';
import WorkspaceCategory from 'shared/ui/components/form-components/WorkspaceCategory.vue';

// Utils
import { get, isEmpty } from 'lodash';

const __vue_script__ = {
    name: 'General',

    components: {
        AppContainerPicker,
        BaseInput,
        BaseSelect,
        ContainerPicker,
        DatetimePicker,
        RegistrationUrlPicker,
        WorkspaceCategory
    },

    extends: WizardStep,

    props: {
        user: {
            type: Object,
            required: true
        },

        infoMessage: {
            type: String,
            default: null
        }
    },

    data() {
        return {
            displayAnonymization: false,
            ready: false,
            timezones: [],
            organization: {},
            organizations: [],
            showOrgField: false,
            serversLocations: [],
            selectedOrg: {},
            selectedServersLocation: null,
            selectedTimezone: null
        };
    },

    computed: {
        /** @returns {Date} */
        minStartDate() {
            if (!this.selectedTimezone) return this.$utils.time.now().add(5, 'minutes').toDate();
            return this.$utils.time.now().add(5, 'minutes').tz(this.selectedTimezone).toDate();
        },

        /** @returns {boolean} */
        isOrgEmpty() {
            return isEmpty(this.selectedOrg);
        },

        /** @returns {boolean} */
        isContainerAppSelected() {
            return !isEmpty(this.form.branded_app);
        },

        /** @returns {boolean} */
        canInsertMultipleCategories() {
            return this.isCategoryEnabled && get(this.selectedOrg, 'workspace_defaults.category_multiselect', false);
        },

        /** @returns {boolean} */
        isCategoryEnabled() {
            return get(this.selectedOrg, 'workspace_defaults.enable_category', false);
        }
    },

    watch: {
        selectedOrg() {
            this.form.orgId = this.selectedOrg._id;
            this.displayAnonymization = this.selectedOrg.enable_anonymization;
            this.cleanCategories();
        },

        selectedServersLocation() {
            this.form.serversLocation = this.selectedServersLocation.value;
        },

        selectedTimezone() {
            this.form.timezone = this.selectedTimezone;
        }
    },

    activated() {
        this.organizations = this.user.orgs.filter(org =>
            org.show_studio_express && this.$services.user.hasPermission('global_actions.create_webinar', {
                org_id: org._id
            })
        );
        if (this.organizations.length > 0) {
            this.organization = this.organizations[0];
            this.selectedOrg = this.organizations[0];
            this.getServersForOrg(this.selectedOrg.name);
            if (this.organizations.length > 1) {
                this.showOrgField = true;
            }
        }

        if (this.form.template) {
            this.$set(this.form, 'branded_app', this.form.template.branded_app);
        }

        this.timezones = this.$utils.time.getAllZones();
        const browserTz = this.$utils.time.getBrowserTimezone();
        this.selectedTimezone = this.form.timezone;

        if (!this.selectedTimezone && this.timezones.includes(browserTz)) {
            this.selectedTimezone = browserTz;
        }

        this.$nextTick(() => this.ready = true);
    },

    methods: {
        /**
         * Get the servers locations for a given organization
         *
         * @param {String} orgName the name of the organization
         *
         */
        async getServersForOrg(orgName) {
            this.serversLocations = [];

            const servers = await this.$services.server.getOrgServers(orgName);

            this.serversLocations = this.$utils.workspaces.getServersLocation(servers);

            if (this.serversLocations && this.serversLocations.length) {
                this.selectedServersLocation = this.serversLocations[0];
            }
        },

        /**
         * Cleans or remove the categories from the form payload
         */
        cleanCategories() {
            if (this.isCategoryEnabled) {
                if (this.form.hasOwnProperty('category')) {
                    this.form.category = this.canInsertMultipleCategories ? undefined : '';
                }

                if (this.form.hasOwnProperty('categories')) {
                    this.form.categories = this.canInsertMultipleCategories ? [] : undefined;
                }
            } else {
                delete this.form.category;
                delete this.form.categories;
            }
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ready)?_c('validation-observer',{ref:"form",staticClass:"workspace-form",attrs:{"tag":"form"}},[(_vm.infoMessage)?_c('div',{staticClass:"alert alert-info"},[_c('p',[_vm._v(_vm._s(_vm.infoMessage))])]):_vm._e(),(_vm.showOrgField)?_c('validation-provider',{attrs:{"rules":"required","slim":true,"name":"organization"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('base-select',{ref:"organization",attrs:{"label":_vm.$t('webinars.form.organization'),"placeholder":_vm.$t('webinars.form.organization_placeholder'),"allow-empty":false,"name":"organization","options-label":"display_name","errors":errors,"track-by":"_id","options":_vm.organizations},model:{value:(_vm.selectedOrg),callback:function ($$v) {_vm.selectedOrg=$$v},expression:"selectedOrg"}})]}}],null,false,635852312)}):_vm._e(),_c('validation-provider',{attrs:{"rules":"required","slim":true,"name":"name"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('base-input',{ref:"name",attrs:{"label":_vm.$t('webinars.form.name'),"type":"text","name":"name","errors":errors,"disabled":_vm.isOrgEmpty},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})]}}],null,false,1686588662)}),_c('validation-provider',{attrs:{"rules":"required","slim":true,"name":"start_time"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('datetime-picker',{ref:"start_time",attrs:{"label":_vm.$t('webinars.form.start_time'),"type":"datetime","show-second":false,"minute-step":30,"name":"start_time","not-before":_vm.minStartDate,"errors":errors,"format":_vm.$const.DEFAULT_DATETIME_FORMAT,"disabled":_vm.isOrgEmpty},model:{value:(_vm.form.startTime),callback:function ($$v) {_vm.$set(_vm.form, "startTime", $$v)},expression:"form.startTime"}})]}}],null,false,3842657082)}),_c('validation-provider',{attrs:{"rules":"required|numeric|min_value:1","slim":true,"name":"duration"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('base-input',{ref:"duration",attrs:{"label":_vm.$t('webinars.form.duration'),"type":"number","name":"duration","errors":errors,"disabled":_vm.isOrgEmpty},model:{value:(_vm.form.duration),callback:function ($$v) {_vm.$set(_vm.form, "duration", $$v)},expression:"form.duration"}})]}}],null,false,385503880)}),(_vm.isCategoryEnabled)?[(_vm.canInsertMultipleCategories)?_c('validation-provider',{attrs:{"slim":true,"name":"categories"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('workspace-category',{attrs:{"focused":_vm.focus == 'categories',"organization":_vm.selectedOrg,"name":"categories","errors":errors},model:{value:(_vm.form.categories),callback:function ($$v) {_vm.$set(_vm.form, "categories", $$v)},expression:"form.categories"}})]}}],null,false,887421016)}):_c('validation-provider',{attrs:{"slim":true,"name":"category"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('workspace-category',{attrs:{"focused":_vm.focus == 'category',"organization":_vm.selectedOrg,"name":"category","errors":errors},model:{value:(_vm.form.category),callback:function ($$v) {_vm.$set(_vm.form, "category", $$v)},expression:"form.category"}})]}}],null,false,711712638)})]:_vm._e(),_c('validation-provider',{attrs:{"rules":"required","slim":true,"name":"timezone"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('base-select',{ref:"timezone",attrs:{"label":_vm.$t('webinars.form.timezone'),"placeholder":_vm.$t('webinars.form.timezone_placeholder'),"name":"timezone","options":_vm.timezones,"options-label":null,"errors":errors,"disabled":_vm.isOrgEmpty},model:{value:(_vm.selectedTimezone),callback:function ($$v) {_vm.selectedTimezone=$$v},expression:"selectedTimezone"}})]}}],null,false,3590768676)}),_c('validation-provider',{attrs:{"rules":"required","slim":true,"name":"servers_location"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('base-select',{ref:"servers_location",attrs:{"label":_vm.$t('webinars.form.servers_location'),"placeholder":_vm.$t('webinars.form.servers_location_placeholder'),"name":"servers_location","options":_vm.serversLocations,"track-by":"value","errors":errors,"disabled":_vm.isOrgEmpty},model:{value:(_vm.selectedServersLocation),callback:function ($$v) {_vm.selectedServersLocation=$$v},expression:"selectedServersLocation"}})]}}],null,false,3600688886)}),_c('validation-provider',{attrs:{"rules":"required","slim":true,"name":"branded_app"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('app-container-picker',{ref:"branded_app",attrs:{"label":_vm.$t('webinars.form.branded_app'),"placeholder":_vm.$t('webinars.form.branded_app_placeholder'),"name":"branded_app","org":_vm.selectedOrg._id,"errors":errors},model:{value:(_vm.form.branded_app),callback:function ($$v) {_vm.$set(_vm.form, "branded_app", $$v)},expression:"form.branded_app"}})]}}],null,false,3385799814)}),_c('registration-url-picker',{ref:"path",attrs:{"label":_vm.$t('webinars.form.url'),"branded-app":_vm.form.branded_app,"name":"registration_path","disabled":_vm.isOrgEmpty || !_vm.isContainerAppSelected},model:{value:(_vm.form.path_name),callback:function ($$v) {_vm.$set(_vm.form, "path_name", $$v)},expression:"form.path_name"}}),(_vm.displayAnonymization)?_c('fieldset',[_c('legend',[_vm._v(_vm._s(_vm.$t('wizards.create_workspace.form.fieldsets.anonymization')))]),_c('div',{staticClass:"alert alert-warning anonymized-alert"},[_vm._v(_vm._s(_vm.$t('wizards.create_workspace.form.anonymization_enabled')))])]):_vm._e()],2):_vm._e()}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "General.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__